import React from 'react';

/**
 * Wraps filter/search controls in the shared `.filters-row` flex layout.
 * Children are plain <Form.Group>s, matching the existing markup. An optional
 * `summary` node (e.g. a result count block) is rendered after the controls.
 */
const FilterBar = ({ children, summary }) => (
  <div className="filters-row">
    {children}
    {summary}
  </div>
);

export default FilterBar;
